import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Divider from '@mui/material/Divider';
import AppTheme from './shared-theme/AppTheme';

const AppAppBar = React.lazy(() => import('./layouts/marketing-page/components/AppAppBar'));
const Footer = React.lazy(() => import('./layouts/marketing-page/components/Footer'));
const MarketingPage = React.lazy(() => import('./layouts/marketing-page/MarketingPage'));
const ContactForm = React.lazy(() => import('./layouts/ContactForm/ContactForm'));
const Blog = React.lazy(() => import('./layouts/Blog/Blog'));
const Certificates = React.lazy(() => import('./layouts/Certificates/Certificates'));
const Offer = React.lazy(() => import('./layouts/Offer/Offer'));
const BlogPostPage = React.lazy(() => import('./layouts/BlogPostPage/BlogPostPage'));
const ClickSpark = React.lazy(() => import('./layouts/marketing-page/animations/ClickSpark/ClickSpark'));

function App(props) {
	return (
		<AppTheme {...props}>
			<Router>
				<Suspense fallback={null}>
					<ClickSpark sparkColor='#91D443' sparkSize={10} sparkRadius={15} sparkCount={8} duration={400}>
						<Suspense fallback={null}>
							<AppAppBar />
						</Suspense>

						<div className='App'>
							<Routes>
								<Route
									path='/'
									element={
										<Suspense fallback={null}>
											<MarketingPage />
										</Suspense>
									}
								/>

								<Route
									path='/register'
									element={
										<Suspense fallback={null}>
											<ContactForm />
										</Suspense>
									}
								/>
								<Route
									path='/blog'
									element={
										<Suspense fallback={null}>
											<Blog />
										</Suspense>
									}
								/>
								<Route
									path='/certificates'
									element={
										<Suspense fallback={null}>
											<Certificates />
										</Suspense>
									}
								/>
								<Route
									path='/offer'
									element={
										<Suspense fallback={null}>
											<Offer />
										</Suspense>
									}
								/>
								<Route
									path='/blog/:postId'
									element={
										<Suspense fallback={null}>
											<BlogPostPage />
										</Suspense>
									}
								/>

								<Route path='*' element={<Navigate to='/' replace />} />
							</Routes>
						</div>

						<Divider />

						<Suspense fallback={null}>
							<Footer />
						</Suspense>
					</ClickSpark>
				</Suspense>
			</Router>
		</AppTheme>
	);
}

export default App;
